export default __webpack_public_path__ + "static/media/tas-navbar-active.634ba9b9.svg";